"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _component = require("@loadable/component");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new function ConfigGlobal() {
    var _this = this;

    (0, _classCallCheck3.default)(this, ConfigGlobal);
    this.loading = null;
    this.loadingForm = null;
    this.loadingGrid = null;
    this.emptyComponent = null;
    this.positionNotification = null;
    this.defaultColDef = {};
    this.iconType = {
        calendar: "calendar",
        select: "caret-down",
        multiSelect: "plus-square",
        edit: "edit",
        search: 'search',
        time: 'field-time'
    };
    this.modal = {
        draggable: false,
        maskClosable: false
    };
    this.store = {};
    this.modalMinimize = [];
    this.grid = {};
    this.form = {};
    this.iconMap = {
        "eye-invisible": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/EyeInvisibleOutlined');
        }),
        eye: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/EyeOutlined');
        }),
        "exclamation-circle": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/ExclamationCircleOutlined');
        }),
        safety: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/SafetyOutlined');
        }),
        message: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/MessageOutlined');
        }),
        warning: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/WarningOutlined');
        }),
        close: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/CloseOutlined');
        }),
        "question-circle": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/QuestionCircleOutlined');
        }),
        plus: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/PlusOutlined');
        }),
        minus: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/MinusOutlined');
        }),
        upload: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/UploadOutlined');
        }),
        delete: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/DeleteOutlined');
        }),
        "file-search": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/FileSearchOutlined');
        }),
        download: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/DownloadOutlined');
        }),
        left: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/LeftOutlined');
        }),
        right: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/RightOutlined');
        }),
        "double-right": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/DoubleRightOutlined');
        }),
        "double-left": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/DoubleLeftOutlined');
        }),
        down: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/DownOutlined');
        }),
        form: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/FormOutlined');
        }),
        up: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/UpOutlined');
        }),
        edit: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/EditOutlined');
        }),
        search: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/SearchOutlined');
        }),
        "caret-down": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/CaretDownOutlined');
        }),
        calendar: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/CalendarOutlined');
        }),
        picture: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/PictureOutlined');
        }),
        percentage: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/PercentageOutlined');
        }),
        "plus-square": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/PlusSquareOutlined');
        }),
        "credit-card": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/CreditCardOutlined');
        }),
        mail: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/MailOutlined');
        }),
        number: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/NumberOutlined');
        }),
        key: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/KeyOutlined');
        }),
        phone: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/PhoneOutlined');
        }),
        chrome: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/ChromeOutlined');
        }),
        "clock-circle": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/ClockCircleOutlined');
        }),
        "field-time": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/FieldTimeOutlined');
        }),
        diff: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/DiffOutlined');
        }),
        fullscreen: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/FullscreenOutlined');
        }),
        "fullscreen-exit": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/FullscreenExitOutlined');
        }),
        sync: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/SyncOutlined');
        }),
        comment: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/CommentOutlined');
        }),
        check: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/CheckOutlined');
        }),
        more: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/MoreOutlined');
        }),
        border: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/BorderOutlined');
        }),
        filter: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/FilterOutlined');
        }),
        like: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/LikeOutlined');
        }),
        rollback: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/RollbackOutlined');
        }),
        "check-square": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/CheckSquareOutlined');
        }),
        menu: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/MenuOutlined');
        }),
        logout: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/LogoutOutlined');
        }),
        unlock: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/UnlockOutlined');
        }),
        user: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/UserOutlined');
        }),
        home: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/HomeOutlined');
        }),
        star: (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/StarOutlined');
        }),
        "menu-unfold": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/MenuUnfoldOutlined');
        }),
        "menu-fold": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/MenuFoldOutlined');
        }),
        "up-square": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/UpSquareOutlined');
        }),
        "down-square": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/DownSquareOutlined');
        }),
        "folder-open": (0, _component2.default)(function () {
            return import('@ant-design/icons/lib/icons/FolderOpenOutlined');
        })
    };

    this.setIconMap = function (icons) {
        _this.iconMap = (0, _assign2.default)(_this.iconMap, icons);
    };
}();